"use client";

export interface AuthModalLayout {
  maxWidth: string;
  padding: string;
}

interface AuthModalLayoutInput {
  isMobile: boolean;
  padding: string;
}

export function getAuthModalLayout({
  isMobile,
  padding,
}: AuthModalLayoutInput): AuthModalLayout {
  if (isMobile) {
    return {
      maxWidth: '100%',
      padding: '1rem 12px',
    };
  }

  return {
    maxWidth: '420px',
    padding,
  };
}
